module.exports = __webpack_public_path__ + "static/shaloh-7b025b654572e8f4cd79b2c3ece7fe63.png";